import { ProfileProgrammeAwardsCardSkeleton } from './profile-programme-awards-card-skeleton'
import React from 'react'
import { Grid } from 'src/component/ui/grid/grid'

export const ProfileSeriesAwardsSkeleton = (): React.ReactElement => {
  return (
    <Grid.Skeleton count={3}>
      <ProfileProgrammeAwardsCardSkeleton />
    </Grid.Skeleton>
  )
}
